// extracted by mini-css-extract-plugin
module.exports = {"drawerMessage":"DrawerMessage-module_drawerMessage_2rnIla0voZ"};